// src/pages/ManagementLogin.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { setManagementSession } from '../utils/managementAuth';

const ManagementLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Real Authentication against Backend
      const api = (await import('../api')).default;

      const res = await api.post('/api/auth/management-login', {
        email: username,
        password: password
      });

      // STRICT VALIDATION
      if (typeof res.data === 'string' && res.data.trim().startsWith('<!DOCTYPE html>')) {
        throw new Error("Server Error: Received HTML instead of JSON. Backend may be down.");
      }

      if (!res.data || !res.data.token) {
        throw new Error("Invalid server response: Missing session token.");
      }

      const user = res.data.user;
      if (user?.role !== 'superadmin') {
        throw new Error("Access Denied: Management is restricted to superadmin accounts.");
      }

      setManagementSession(res.data.token, user);
      navigate('/management/dashboard');

    } catch (err) {
      console.error("Admin Login Failed:", err);
      const data = err.response?.data;
      const detail = Array.isArray(data?.details) ? data.details.join('. ') : null;
      setError(data?.message || detail || data?.error || err.message || 'Login failed. Please check backend connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-4 d-flex align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card shadow border-0">
              <div className="card-body p-4">
                <div className="text-center mb-4">
                  <h2 className="card-title text-danger">
                    <i className="las la-user-shield me-2"></i>
                    Superadmin Login
                  </h2>
                  <p className="text-muted">Restricted to superadmin accounts</p>
                </div>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">Superadmin Email or Username</label>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      placeholder="aditya@diggity.us"
                      autoComplete="username"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-danger w-100 py-2"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Signing In...
                      </>
                    ) : (
                      'Sign in to Management'
                    )}
                  </button>
                </form>

                <div className="text-center mt-3">
                  <Link to="/home" className="text-muted text-decoration-none">
                    <i className="las la-arrow-left me-1"></i>
                    Back to Main Site
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagementLogin;